module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-9b0d76f8.png";